import { useEffect, useRef, useState } from "react";

import { buildOpsMqttClient, type MqttStatus, type OpsMqttClient } from "../lib/mqtt";

let _client: OpsMqttClient | null = null;
let _building: Promise<OpsMqttClient> | null = null;

async function getClient(): Promise<OpsMqttClient> {
  if (_client) return _client;
  if (_building) return _building;
  _building = buildOpsMqttClient().then((c) => {
    _client = c;
    return c;
  });
  return _building;
}

export function useMqttSubscription(
  topic: string,
  handler: (payload: unknown) => void,
) {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => {
    let cleanup: (() => void) | undefined;
    let cancelled = false;
    void getClient().then((client) => {
      if (cancelled) return;
      cleanup = client.subscribe(topic, (payload) => handlerRef.current(payload));
    });
    return () => {
      cancelled = true;
      cleanup?.();
    };
  }, [topic]);
}

export function useMqttStatus(): MqttStatus {
  const [status, setStatus] = useState<MqttStatus>("idle");
  useEffect(() => {
    let timer: number | null = null;
    void getClient().then((client) => {
      const tick = () => {
        setStatus(client.status());
        timer = window.setTimeout(tick, 1000);
      };
      tick();
    });
    return () => {
      if (timer !== null) window.clearTimeout(timer);
    };
  }, []);
  return status;
}
